// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WjiKEV7dB01lXJKGJZVY {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.WjiKEV7dB01lXJKGJZVY .LmrRZVFyOsyCwB2rivqe {
    width: 100%;
    margin-right: 20px;
}

.WjiKEV7dB01lXJKGJZVY input,
.LmrRZVFyOsyCwB2rivqe input {
    color: black;
}

.UHP6KeYWiTfrBYdiFBfC input {
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
}

.RfQqPYnPQ6T1dnaU41tx {
    font-size: 12px;
    margin-top: 4px;
    text-align: left;
}

.UHP6KeYWiTfrBYdiFBfC .RfQqPYnPQ6T1dnaU41tx {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}
}

.eI1UywC62asVYQ8bLEqP {
    display: block;
    margin-bottom: 0;
}

.eI1UywC62asVYQ8bLEqP input {
    height: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Input/LocationInput/LocationInput.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,0DAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["@value colors: \"../../style/colors.css\";\n@value color-error from colors;\n\n.row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.row .inputContainer {\n    width: 100%;\n    margin-right: 20px;\n}\n\n.row input,\n.inputContainer input {\n    color: black;\n}\n\n.error input {\n    border-color: color-error;\n}\n\n.hint {\n    font-size: 12px;\n    margin-top: 4px;\n    text-align: left;\n}\n\n.error .hint {\n    color: color-error\n}\n\n.countryInput {\n    display: block;\n    margin-bottom: 0;\n}\n\n.countryInput input {\n    height: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../style/colors.css"`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"row": `WjiKEV7dB01lXJKGJZVY`,
	"inputContainer": `LmrRZVFyOsyCwB2rivqe`,
	"error": `UHP6KeYWiTfrBYdiFBfC`,
	"hint": `RfQqPYnPQ6T1dnaU41tx`,
	"countryInput": `eI1UywC62asVYQ8bLEqP`
};
export default ___CSS_LOADER_EXPORT___;
